import { WarningMessages } from 'constants/Warning.constants';

import { selectEntities } from '@polyai/stream/store/reducers/entities/selectors';
import { EntityIcon } from '@polyai/ui/components/atoms/Icons';
import { PopupMenuItem } from '@polyai/ui/components/molecules/PopupMenu';

import { useActionsContext } from 'components/molecules/RichTextInputV2/hooks/useActions';
import { useAppSelector } from 'hooks/reduxHooks';
import { useEntitySidebar } from 'screens/FlowDetails/context/EntitySidebarContext';
import { useViewMode } from 'screens/withPermissions/useViewMode';
import { ENTITY_PREFIX } from '../../constants';
import type {
  ActionTagContentProps,
  ActionTypeInput,
  ActionTypeOutput,
} from '../../types';

const EntityTagContent = ({ id, remove }: ActionTagContentProps) => {
  const entities = useAppSelector(selectEntities);
  const { customState } = useActionsContext();
  const entity = entities.find(e => e.id === id);
  const { isEditable } = useViewMode();
  const { openEntitySidebar } = useEntitySidebar();

  return (
    <>
      {entity && (
        <PopupMenuItem
          onClick={() => {
            openEntitySidebar({
              entityId: entity.id,
              stepType: customState?.flowStepType,
            });
          }}
        >
          {isEditable ? 'Edit' : 'View'}
        </PopupMenuItem>
      )}
      {isEditable && (
        <PopupMenuItem isDelete onClick={remove}>
          Remove
        </PopupMenuItem>
      )}
    </>
  );
};

export const useEntityActionType = ({
  id,
}: ActionTypeInput): ActionTypeOutput => {
  const { isEntitiesEnabled } = useActionsContext();
  const entities = useAppSelector(selectEntities);
  const entity = entities.find(e => e.id === id);
  const warning = !entity ? WarningMessages.ENTITY_NOT_EXIST : undefined;

  return {
    Content: EntityTagContent,
    Icon: EntityIcon,
    name: entity?.name ?? id,
    warning,
    prefix: ENTITY_PREFIX,
    isEnabled: isEntitiesEnabled,
    isLoading: false,
  };
};
